import React from "react";
import HomeDashboardLoading from "../../pages/Dashboard/HomeDashboardLoading";
import "./PanelStates.scss";

/** Route / Suspense fallback — panel ile aynı premium loading */
const LoadingSpinner = ({ tip = "Yükleniyor…" }) => {
 return (
  <div className="kuzem-route-loading">
   <HomeDashboardLoading tip={tip} />
  </div>
 );
};

export default LoadingSpinner;
